import { SectionContainer } from '@/pages/shared-components/SectionContainer'
import { ManageSupportTeamsFormV2 } from '../Forms/ManageSupportTeamsFormV2'
import { useCurrentWorkspace } from '../useCurrentWorkspace'
import { IconEditOutline } from '@icons/IconEditOutline'
import { Button } from '@/components/shadcn/button'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { ErrorComponent } from '@/ui-legacy/ErrorComponent'
import { IconBg } from '@/components/ui/IconBg'
import { IconCommunityOutline } from '@icons/IconCommunityOutline'
import { useQueryClient } from '@tanstack/react-query'
import { useSessionStorage } from '@/hooks/useSessionStorage'
import { useState } from 'react'
import { isPlatformAdmin, isSuperUser } from '@/util/roles'
import { useRestClient } from '@/contexts/QueryProvider'
import { useCallback } from 'react'

export function SupportTeamsSection() {
  const queryClient = useQueryClient()
  const workspace = useCurrentWorkspace()
  const { workspaceId } = workspace

  const [userRole] = useSessionStorage('roles', 1)
  const [isEditSupportTeamsAllowed] = useState(() => {
    return isPlatformAdmin(userRole) || isSuperUser(userRole)
  })

  const { getWorkspacesApiGetSupportTeamsWorkspace } = useRestClient()

  const {
    data: supportTeams,
    isPending: supportTeamsPending,
    isError: supportTeamsError,
  } = getWorkspacesApiGetSupportTeamsWorkspace.useQuery(
    {
      query: { workspaceId },
    },
    {
      enabled: !!workspaceId,
    }
  )

  const onSupportTeamsSubmit = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', 'supportTeam', workspaceId] })
  }, [queryClient, workspaceId])
  return (
    <SectionContainer
      title="Support teams"
      description="Manage the support teams for the workspace."
      action={
        <ManageSupportTeamsFormV2
          sheetTitle="Manage Support Teams"
          sheetDescription="Manage the support teams for the workspace."
          sheetTriggerTooltip="Manage support teams"
          selectedWorkspace={workspace}
          onSubmit={onSupportTeamsSubmit}
          sheetTrigger={
            <Button disabled={!isEditSupportTeamsAllowed} variant="ghost" size="icon">
              <IconEditOutline />
            </Button>
          }
        />
      }
    >
      <div className="flex flex-row flex-wrap gap-2 whitespace-nowrap text-base">
        {supportTeamsPending ? (
          <LoadingComponent text="Loading support teams..." />
        ) : supportTeamsError ? (
          <ErrorComponent />
        ) : supportTeams.length === 0 ? (
          <span className="font-light italic">...No support teams found...</span>
        ) : (
          supportTeams.map((team, i) => (
            <div className="flex items-center gap-x-1" key={team.id}>
              <IconBg tooltip="Support team" className="size-8 bg-secondary/30">
                <IconCommunityOutline className="size-4 text-muted-foreground" />
              </IconBg>
              <span key={team.id}>
                {team.name}
                {i < supportTeams.length - 1 ? ',' : ''}
              </span>
            </div>
          ))
        )}
      </div>
    </SectionContainer>
  )
}
